<template lang="pug">
    #dashboard(role="tablist")
        b-card.mb-1(no-body)
            b-collapse(v-model="tab1", role="tabpanel")
                b-card-body
                    b-card-text We studied the LA County fitness consumer over 6 months in 2019, exploring their workout habits and travel routines.
                    b-card-text(style="height: 1em")
                        a(href="#", v-if="inTransition == false", @click="learnAboutGyms") Learn about the gyms.
        b-card.mb-1(no-body)
            b-collapse(v-model="tab2", role="tabpanel")
                b-card-body
                    b-card-text
                        p Over 1000 fitness centers and gyms were analyzed for consumer behavior and patterns.
                        p Here's what we discovered:
                        ul
                            li Gyms see their most significant usage from 6-7pm
                            li Tuesday is by far the most popular day to work out
                            li Most gym goers workout for 50mins - 1hr.
                            li 25% of gym goers stick to their standard gym time month over month
                    b-card-text(style="height: 1em")
                        a(href="#", v-if="inTransition == false", @click="dayInTheLife") A Day in the Life of One Gym.

        b-card.mb-1(no-body)
          b-collapse(v-model="tab3", role="tabpanel")
            b-card-body(style="height: 600px")
                p  we then focused on a single gym in West Hollywood to show what the traffic looks like when we took 6 months of traffic, and reduced it to one day that we then compressed to 90 seconds.
                AnalogClock(:currentMinute="counter")
                //- .play-controls
                    b-button(icon-right="play" @click="toggleRun()" v-if="isRunning == false")
                    b-button(icon-right="pause" @click="toggleRun()" v-if="isRunning == true")
</template>

<script>
import AnalogClock from "@/components/AnalogClock";
export default {
    components: {
        AnalogClock
    },
    props: { 
        counter: {type: Number, default: 400},
        inTransition: Boolean,
        isRunning: Boolean,
        isOpen: {type: Number, default: 0}
    },
    data() {
        return {
            tab1: true,
            tab2: false,
            tab3: false
        }
    },
  watch: {
      isOpen(i) {
          if (i == 1) {
              this.tab1 = true;
              this.tab2 = false;
              this.tab3 = false;
          } else if (i == 2) {
              this.tab1 = false;
              this.tab2 = true;
              this.tab3 = false;
          } else if (i == 3) {
              this.tab1 = false;
              this.tab2 = false;
              this.tab3 = true
          }
      }
  },
    methods: {
        learnAboutGyms() {
            this.$parent.$emit('learnAboutGyms')
        },
        dayInTheLife() {
            this.$parent.$emit('dayInTheLife')
        }
    }
};
</script>

<style lang="scss" scoped>
.clock-wrapper {
  position: relative;
  height: 50vh;
}
.play-controls {
  margin-top: calc(20vw + 5px);
}

#dashboard {
  position: absolute;
  z-index: 1;
  width: calc(20vw + 40px);
  max-width: 400px;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: #fcf3d9;
//   text-align: center;
  min-height: 1000px;

  li {
      list-style-type: disc;
  }

  &.inTransition {
    .cover {
      background-color: rgba($color: #000000, $alpha: 0.2);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      cursor: wait;
    }
  }
  a.hide-link {
      color: #fff
  }
  .card {
      border: none;
      box-shadow: none;
  }
}
</style>
